import type { LeadStage, PipelineStage } from "@school-sales-ai/shared";
import { stageColorClasses } from "@/lib/stage-colors";

// Fallback order/labels for the 7 seeded keys. Pipeline columns are now dynamic
// (per client, from `usePipelineStages`); these constants are the pre-load
// fallback and are still used by the deferred Reports module. Prefer the
// `stageLabel` / `stageClasses` resolvers below, which consult the live columns.
export const STAGE_ORDER: LeadStage[] = [
  "new",
  "qualifying",
  "warm",
  "hot",
  "closing",
  "enrolled",
  "discarded",
];

export const STAGE_LABELS: Record<string, string> = {
  new: "Nuevo",
  qualifying: "Calificando",
  warm: "Tibio",
  hot: "Caliente",
  closing: "Cerrando",
  enrolled: "Inscrito",
  discarded: "Descartado",
};

export const STAGE_CLASSES: Record<string, string> = {
  new: "bg-stage-nuevo-bg text-stage-nuevo-fg",
  qualifying: "bg-stage-calificando-bg text-stage-calificando-fg",
  warm: "bg-stage-tibio-bg text-stage-tibio-fg",
  hot: "bg-stage-caliente-bg text-stage-caliente-fg",
  closing: "bg-stage-cerrando-bg text-stage-cerrando-fg",
  enrolled: "bg-stage-inscrito-bg text-stage-inscrito-fg",
  discarded: "bg-stage-descartado-bg text-stage-descartado-fg",
};

// Resolves a column's display label from the live columns, falling back to the
// seeded label and finally the raw key (e.g. a lead sitting in a deleted column).
export function stageLabel(
  key: string,
  stages: PipelineStage[] | undefined,
): string {
  return (
    stages?.find((s) => s.key === key)?.label ?? STAGE_LABELS[key] ?? key
  );
}

// Resolves a column's badge classes from the live columns (explicit color →
// seeded classes → neutral).
export function stageClasses(
  key: string,
  stages: PipelineStage[] | undefined,
): string {
  const stage = stages?.find((s) => s.key === key);
  return stageColorClasses(key, stage?.color ?? null);
}
